import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  constructor() { }
  public regexValidators = {
    phone: /(?!\+.*\+)^\+?([\ ]*\d[\-.,\ ]?){0,4}(\(\+?\d{1,4}\))?([\ ]*\d[\-.,\ ]?){2,}\d$/,
    email: /^([\w\-_]+(\.[\w\-_]+)*)@(([\w\-_]+\.)+[a-z]{2,})$/i,
    domain: /^(?!-)[a-zA-Z0-9_-]*$/,
    url: /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/\S*)?$/
  };

  public Match(firstControlName, secondControlName) {
    return (AC: AbstractControl) => {
      const firstControlValue = AC.get(firstControlName).value;
      const secondControlValue = AC.get(secondControlName).value;
      if (firstControlValue === secondControlValue) {
        return null;
      } else {
        AC.get(secondControlName).setErrors({ MatchFields: false });
      }
    };
  }

  public ValidatePin(controlName) {
    return (AC: AbstractControl) => {
      const controlValue = AC.get(controlName).value;

      if (this.pinLength(controlValue) === false) {
        AC.get(controlName).setErrors({ PinLengthInvalid: true });
      }

      if (this.pinIsNumber(controlValue) === false) {
        AC.get(controlName).setErrors({ PinIsNaN: true });
      }

      if (this.pinEachNumberOccurrence(controlValue) === false) {
        AC.get(controlName).setErrors({ DigitOccurrenceInvalid: true });
      }

      if (this.pinConsecutiveNumbers(controlValue) === false) {
        AC.get(controlName).setErrors({ ConsecutiveNumbersInvalid: true });
      }
    };
  }

  public MatchPin(firstControlName, secondControlName) {
    return (AC: AbstractControl) => {
      const firstControlValue = AC.get(firstControlName).value;
      const secondControlValue = AC.get(secondControlName).value;
      if (firstControlValue === secondControlValue) {
        return null;
      } else {
        AC.get(secondControlName).setErrors({ MatchFields: false });
      }
    };
  }

  // checks if PIN has at least 8 digits
  public pinLength(controlValue) {
    if (controlValue.length >= 8) {
      return null;
    } else {
      return false;
    }
  }

  // checks if PIN contains only numbers
  public pinIsNumber(controlValue) {
    if (controlValue.match(/^[0-9]*$/)) {
      return null;
    } else {
      return false;
    }
  }

  // checks if any of the PIN digits are present more than 3 times 
  public pinEachNumberOccurrence(controlValue) {
    const counts = {};
    let ch;
    let count;
    const occurences = [];

    for (let i = 0, len = controlValue.length; i < len; ++i) {
      ch = controlValue.charAt(i);
      count = counts[ch];
      counts[ch] = count ? count + 1 : 1;
    }

    for (ch in counts) {
      if (counts[ch] > 3) {
        occurences.push(counts[ch]);
      }
    }

    for (const value of occurences) {
      if (value < 4) {
        return null;
      } else {
        return false;
      }
    }
  }

  // checks if PIN contains more than 3 consectutive numbers
  public pinConsecutiveNumbers(controlValue) {
    const controlValues = [];
    let ch;
    for (let i = 0, len = controlValue.length; i < len; ++i) {
      ch = parseInt(controlValue.charAt(i), 10);
      controlValues.push(ch);
    }

    if (this.checkCons(controlValues)) {
      return false;
    } else {
      return null;
    }
  }

  public checkCons(array) {
    let cons = false;
    let count = 0;
    for (let i = 0; i < array.length; i++) {
      if (array[i] + 1 === array[i + 1]) {
        count++;
      } else {
        count = 0;
      }
      if (count === 3) {
        cons = true;
      }
    }
    return cons;
  }

}
